import styles from "./style/EnterpriseAlertSwitch.module.scss";

const EnterpriseAlertSwitch = ({
  isChecked,
  onChange,
  isTransparent,
  color = { on: "#5856d6", off: "#dddddd" },
}) => {
  return (
    <label className={styles.switch}>
      <input type='checkbox' checked={isChecked} onChange={onChange} />
      <span
        className={isTransparent ? styles.sliderTransparent : styles.slider}
        style={{
          backgroundColor: isChecked ? color.on : color.off,
        }}></span>
    </label>
  );
};

export default EnterpriseAlertSwitch;
